"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TonicAirDropperFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract Tonic",
                name: "tonic_",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Blacklisted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "claimant",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "TonicClaimed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unblacklisted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "addToBlacklist",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "claimTonic",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "bytes32",
                name: "messageHash",
                type: "bytes32",
            },
        ],
        name: "getEthSpecificMessageHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "claimant",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "verifierAddress",
                type: "address",
            },
        ],
        name: "getMessageHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "isClaimed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "signer",
                type: "address",
            },
            {
                internalType: "address",
                name: "claimant",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "verifierAddress",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "isSignatureValid",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "bytes32",
                name: "ethSpecificMessageHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "recoverSigner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "removeFromBlacklist",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "splitSignature",
        outputs: [
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "signer",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "messageHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "verify",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
class TonicAirDropperFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(tonic_, overrides) {
        return super.deploy(tonic_, overrides || {});
    }
    getDeployTransaction(tonic_, overrides) {
        return super.getDeployTransaction(tonic_, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TonicAirDropperFactory = TonicAirDropperFactory;
TonicAirDropperFactory.bytecode = _bytecode;
TonicAirDropperFactory.abi = _abi;
//# sourceMappingURL=TonicAirDropperFactory.js.map